<article class="message">
    <core-helper-box-header-user-date [date]="message.date" [user]="message.user" [posText]="'LEFT A <strong>MESSAGE</strong>'">
    </core-helper-box-header-user-date>
    <div class="content">
        <p [innerHTML]="message.text">{{message.text}}</p>
        <div class="preview" *ngIf="message.files.length > 0">
            <a href="javascript:void(0)" (click)="toggleShow()">
                <core-preview-first [files]="message.files" [format]="'small-width'"></core-preview-first>
            </a>
            <div *ngIf="showFilesList" class="list-download-div">
                <core-files-list-download [files]="message.files" (onClick)="fileClick($event)"></core-files-list-download>
            </div>
        </div>
    </div>
</article>
